import axios from 'axios';
import {
  type COMPLETED_REQUEST_STATUSES,
  type MEDICAL_RECORDS_TYPE,
} from '../constants/types';
import {URLS} from '../constants/urls';

export const completeMedicalRecordsRequest = async (
  consumerUuid: string | undefined,
  documentType: MEDICAL_RECORDS_TYPE | undefined,
  userComment: string | undefined,
  status: COMPLETED_REQUEST_STATUSES,
  storedReferenceCode: string
): Promise<void> => {
  await axios.post(
    URLS.COMPLETE_REQUEST,
    {
      consumer_uuid: consumerUuid ?? '',
      document_type: documentType ?? '',
      comment: userComment ?? '',
      status,
    },
    {
      headers: {
        'x-provider-reference-code': storedReferenceCode,
      },
    }
  );
};
